import { isResultError, isResultSuccess, PublicSettingsSchema } from '../types';
/**
 * PublicSettings service
 */
class PublicSettingsService {
    publicSettingsAdapter;
    storeService;
    constructor({ publicSettingsAdapter, storeService }) {
        this.publicSettingsAdapter = publicSettingsAdapter;
        this.storeService = storeService;
    }
    /**
     * Retrieve public settings using the adapter.
     */
    async loadPublicSettings() {
        const publicSettingsStore = this.storeService.getPublicSettings();
        const data = publicSettingsStore.data();
        if (!data || Object.keys(data).length === 0) {
            const result = await this.publicSettingsAdapter.getPublicSettings();
            if (isResultSuccess(result)) {
                const response = PublicSettingsSchema.parse(result.response);
                // build publicSettings with default values
                const publicSettings = {
                    timeZone: !response.headers['x-tz'] || response.headers['x-tz'] === 'undefined'
                        ? 'Europe/Paris'
                        : response.headers['x-tz'],
                    hideDemandeDepotPieces: response.data?.aides?.hideDemandeDepotPieces ?? false,
                    createDemande: response.data?.dashboard?.createDemande ?? true, // set createDemande to true if there is no value
                };
                publicSettingsStore.SET_DATA(publicSettings);
            }
        }
        return publicSettingsStore.data();
    }
    async getPublicSettingsGestionDepotDemandes() {
        const result = await this.publicSettingsAdapter.getPublicSettingsGestionDepotDemandes();
        if (isResultError(result)) {
            throw result.error;
        }
        return result.response;
    }
}
export { PublicSettingsService };
//# sourceMappingURL=public-settings-service.js.map